import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    loader: true,
    supplierGroupDetails: '',
    error: ''
};

export default function purchaseSetupReducer(state = initState, action) {
    switch (action.type) {
        case actions.SUPPLIERGROUP_DETAILS_START: {
            return {
                ...state,
                loader: 'true',
            };
        }
        case actions.SUPPLIERGROUP_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                supplierGroupDetails: action.payload,
            };
        }
        case actions.SUPPLIERGROUP_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.CLEAR_SALES_SETUP_DETAILS_START: {
            return {
                ...state,
            };
        }
        case actions.CLEAR_SALES_SETUP_DETAILS_SUCCESS: {
            return {
                ...state,
                loader: true
            };
        }
        default:
            return state;
    }
}